
/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-09 14:15:05
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description:政策文件树
 * 
 * @param {
 * }
 * @return {*}
 */
export const globalSearch = (data) => {
    return axios.request({
        url: `${API_MAIN}/globalSearch`,
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/search.js